import EventEmitter from 'events';

const event = new EventEmitter();
const successLoginEventName = 'authsuite-success-login';
const failLoginEventName = 'authsuite-fail-login';

const loginEvent = {
    onSuccess: (callback) => event.on(successLoginEventName, callback),
    emitSuccess: (data) => event.emit(successLoginEventName, data),
    onFail: (callback) => event.on(failLoginEventName, callback),
    emitFail: (data) => event.emit(failLoginEventName, data),
};

export default loginEvent;
